import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 3.8v16.4a1.2 1.2 0 0 0 1.84 1.02l13-8.2a1.2 1.2 0 0 0 0-2.04l-13-8.2A1.2 1.2 0 0 0 7 3.8" }));
export default SvgPlay;
